import type { Genre } from '../data/types.ts';

export interface GenreMeta {
  name: Genre;
  slug: string;
  blurb: string;
}

export const GENRES: readonly GenreMeta[] = [
  {
    name: 'Action',
    slug: 'action',
    blurb: 'High-octane thrills and impossible odds.',
  },
  {
    name: 'Drama',
    slug: 'drama',
    blurb: 'Stories that move you from the inside.',
  },
  {
    name: 'Thriller',
    slug: 'thriller',
    blurb: "Edge-of-seat tension from start to credits.",
  },
  {
    name: 'Comedy',
    slug: 'comedy',
    blurb: 'Life is absurd — might as well laugh.',
  },
  {
    name: 'Horror',
    slug: 'horror',
    blurb: 'Doors that should stay shut.',
  },
  {
    name: 'Romance',
    slug: 'romance',
    blurb: 'Love in every unexpected place.',
  },
  {
    name: 'Documentary',
    slug: 'documentary',
    blurb: 'The world is stranger than fiction.',
  },
  {
    name: 'Family',
    slug: 'family',
    blurb: 'Adventures for every age.',
  },
];

const BY_SLUG = new Map(GENRES.map((g) => [g.slug, g]));

export function genreBySlug(slug: string): GenreMeta | undefined {
  return BY_SLUG.get(slug);
}
